export default __webpack_public_path__ + "23d3ee215b034c228f85dea9292e4e1c.png";